import axios from 'axios';
import { apiProfilesUrl } from '../config';
import populatePropertys from '../utils/populatePropertys';

/**
 * Get profiles via ajax.
 *
 * @author Yves Matta <yves.matta@qochealth.com>
 * @param {{}} props
 * @param {{}} [props.requestConfig] - additional config for request
 * @param {string} [props.orgGroupUUID] - target orgGroupUUID
 * @param {string} [props.orgLocationUUID] - target orgLocationUUID
 * @param {string} [props.orgUnitUUID] - target orgUnitUUID
 * @param {string} [props.orgUUID] - target orgUUID
 * @param {string} [props.profileUUID] - target profileUUID
 * @param {string} [props.roleUUID] - target roleUUID
 * @param {string} [props.tenantUUID] - target tenantUUID
 * @returns {Promise}
 */
const getProfiles = (props = {}) => {
  const { requestConfig } = props;

  const method = 'get';
  const url = apiProfilesUrl;

  const populatedPropertys = populatePropertys({
    capDestProp: true,
    propertyNames: [
      'orgGroupUUID',
      'orgLocationUUID',
      'orgUnitUUID',
      'orgUUID',
      'profileUUID',
      'roleUUID',
      'tenantUUID'
    ],
    source: props
  });

  return axios({
    method,
    params: populatedPropertys,
    url,
    ...requestConfig
  });
};

export default getProfiles;



// WEBPACK FOOTER //
// ./src/qoc-sdk/library/getProfiles.js